export const textLang: any = {
    us: {
        title: 'Swap EcoCredits for Splendid Gifts',
        desc: '',
        btn: 'Click for EcoCredits Rewards',
    },
    jp: {
        title: 'ポイントをプレゼントと交換する',
        desc: '',
        btn: 'エコポイント特典をクリック',
    },
    de: {
        title: 'EcoCredits gegen tolle Geschenke eintauschen',
        desc: '',
        btn: 'Klicken Sie für EcoCredits-Belohnungen',
    },
    fr: {
        title: 'Échangez vos EcoCredits contre de superbes cadeaux.',
        desc: '',
        btn: 'Cliquez pour les récompenses EcoCredits',
    },
    es: {
        title: 'Intercambia EcoCredits por regalos espléndidos',
        desc: '',
        btn: 'Haga clic para recompensas EcoCredits',
    },
    it: {
        title: 'Scambia gli EcoCredits con fantastici regali',
        desc: '',
        btn: 'Clicca per le ricompense EcoCredits',
    },
    kr: {
        title: 'EcoCredits를 멋진 선물로 교환하세요',
        desc: '',
        btn: 'EcoCredits 보상을 받으려면 클릭하세요',
    },
    br: {
        title: 'Troque seus EcoCredits por Presentes Especiais.',
        desc: '',
        btn: 'Clique para obter suas Recompensas em EcoCredits',
    },
    mx: {
        title: 'Intercambia EcoCredits por regalos magníficos',
        desc: '',
        btn: 'Haz clic para obtener recompensas de EcoCredits',
    },
    ph: {
        title: 'Swap EcoCredits for Splendid Gifts',
        desc: '',
        btn: 'Click for EcoCredits Rewards',
    },
    nl: {
        title: 'Wissel EcoCredits in voor prachtige cadeaus',
        desc: '',
        btn: 'Klik voor EcoCredits-beloningen',
    },
};
